import { marked } from 'marked';

import { MENTION_TOKEN_PATTERN } from '@/helpers/assignPersonMention';

// Converts markdown syntax to HTML if markdown characters are detected in the message
// Returns the original message if no markdown is found
// First preserves special tokens like {{@...}} to prevent markdown processing within them
const convertMarkdownToHtml = (message: string): string => {
  // Store special tokens temporarily
  const tokenMap = new Map<string, string>();
  let tokenCounter = 0;

  // Replace {{@...}} tokens with temporary placeholders
  const messageWithPlaceholders = message.replace(MENTION_TOKEN_PATTERN, (match: string) => {
    const placeholder = `{{TEMPTAGUSERTOKEN${tokenCounter}}}`;
    tokenMap.set(placeholder, match);
    tokenCounter += 1;
    return placeholder;
  });

  // Process markdown on the message with placeholders
  const processedMessage = messageWithPlaceholders.replace(
    /(\*\*.*?\*\*|_.*?_|`.*?`|\[.*?\]\(.*?\))/g,
    (match: string) => {
      try {
        const parsed = marked.parseInline(match);
        return typeof parsed === 'string' ? parsed : match;
      } catch (e) {
        return match;
      }
    },
  );

  // Restore the original tokens
  let finalMessage = processedMessage;
  tokenMap.forEach((originalToken, placeholder) => {
    finalMessage = finalMessage.replace(placeholder, originalToken);
  });

  return finalMessage;
};

export default convertMarkdownToHtml;
